import { render, staticRenderFns } from "./DUploadFile.vue?vue&type=template&id=459cd3d4"
import script from "./DUploadFile.vue?vue&type=script&lang=js"
export * from "./DUploadFile.vue?vue&type=script&lang=js"
import style0 from "./DUploadFile.vue?vue&type=style&index=0&id=459cd3d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports